import heroImage from "../assets/home_splash_bookkeeping.png";

export default function HomeMobile() {
  return (
    <div className="page home">

      {/* ===== ORIGINAL SIMPLE WELCOME ===== */}
      <section className="card" style={{ marginTop: "1.5rem" }}>
        <h2>Welcome to 1OPPS (MOBILE)</h2>
        <p>
          A modern platform connecting businesses with trusted bookkeeping and
          business support professionals.
        </p>
      </section>

      {/* ===== NEW HERO / INTAKE CTA ===== */}
      <section className="hero">
        <div className="hero-text">
          <h1>Bookkeeping & Business Support, Simplified</h1>
          <p>
            Submit your project intake and get matched with vetted professionals
            for bookkeeping, financial reporting, budgeting, and administrative
            support.
          </p>

          <div className="hero-actions">
            <a href="/signup" className="btn primary">
              Create an Account
            </a>
            <a href="/intake/start" className="btn secondary">
              Start Project Intake
            </a>
          </div>
        </div>

        <div className="hero-image">
          <img
            src={heroImage}
            alt="Bookkeeping and financial services illustration"
          />
        </div>
      </section>

      {/* ===== ORIGINAL CONTENT (ENHANCED) ===== */}
      <section className="features">
        <div className="card">
          <h3>What We Do</h3>
          <p>
            We help businesses streamline financial operations by connecting
            them with experienced professionals.
          </p>
        </div>

        <div className="card">
          <h3>How It Works</h3>
          <p>
            Complete a short intake, review your options, and start working with
            a trusted bookkeeper.
          </p>
        </div>

        <div className="card">
          <h3>Why 1OPPS</h3>
          <p>
            Flexible engagement models, secure data handling, and reliable
            ongoing support.
          </p>
        </div>
      </section>

      {/* ===== FINAL CTA ===== */}
      <section className="card" style={{ marginTop: "2rem", textAlign: "center" }}>
        <h3>Ready to Get Started?</h3>
        <p>
          Submit your project intake and let us handle the rest.
        </p>
        <a href="/intake/start" className="btn primary"
          style={{"marginTop":"10px"}}
        >
          
          Begin Intake
        </a>
      </section>

    </div>
  );
}
